export const MANAGE_INVENTORY_PERMISSIONS = [
    'ADMIN',
    'CROP_MANAGEMENT',
    'MANAGE_INVENTORY',
];
export const MANAGE_LOT_PERMISSIONS = [
    ...MANAGE_INVENTORY_PERMISSIONS,
    'MANAGE_LOTS',
];

export const MI_MANAGE_FILES_PERMISSION = [
    ...MANAGE_LOT_PERMISSIONS,
    'UPDATE_LOTS',
    'MI_MANAGE_FILES'
];

export const LOT_LABEL_PRINTING_PERMISSIONS = [
    ...MANAGE_LOT_PERMISSIONS, 'LOT_LABEL_PRINTING'
];

export const MANAGE_GERMPLASM_PERMISSIONS = [
    'ADMIN',
    'GERMPLASM',
    'MANAGE_GERMPLASM'
];

export const SEARCH_GERMPLASM_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'SEARCH_GERMPLASM'
];

export const IMPORT_GERMPLASM_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'IMPORT_GERMPLASM',
    'IG_CREATION_OPTIONS',
    'IG_MATCH_TO_EXISTING',
    'IG_FORCE_CREATE'
];

export const FORCE_CREATE_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'IMPORT_GERMPLASM',
    'IG_CREATION_OPTIONS',
    'IG_FORCE_CREATE'
];

export const MATCH_TO_EXISTING_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'IMPORT_GERMPLASM',
    'IG_CREATION_OPTIONS',
    'IG_FORCE_CREATE'
];

export const IMPORT_GERMPLASM_UPDATES_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'IMPORT_GERMPLASM_UPDATES'
];

export const ADD_GERMPLASM_ENTRIES_TO_LIST_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'MG_ADD_ENTRIES_TO_LIST'
];

export const DELETE_GERMPLASM_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'DELETE_GERMPLASM'
];

export const MERGE_GERMPLASM_PERMISSIONS = [
    'ADMIN',
    'GERMPLASM',
    'MANAGE_GERMPLASM',
    'MERGE_GERMPLASM'
];

export const CODE_GERMPLASM_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'CODE_GERMPLASM'
];

export const GERMPLASM_LABEL_PRINTING_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'GERMPLASM_LABEL_PRINTING'
];

export const SITE_ADMIN_PERMISSIONS = [
    'ADMIN',
    'ADMINISTRATION',
    'SITE_ADMIN'
];

export const FIELDMAP_MANAGER_PERMISSIONS = [
    'ADMIN',
    'FIELDMAP_MANAGER'
];

export const ADD_PROGRAM_PERMISSION = [
    'ADMIN',
    'CROP_MANAGEMENT',
    'ADD_PROGRAM',
    'MANAGE_PROGRAMS'
];

export const MANAGE_STUDIES_PERMISSIONS = [
    'ADMIN',
    'STUDIES',
    'MANAGE_STUDIES'
];

export const MS_MANAGE_FILES_OBSERVATIONS_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_OBSERVATIONS',
    'MS_MANAGE_FILES_OBSERVATIONS'
];

export const MANAGE_FILES_ENVIRONMENT_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_ENVIRONMENT',
    'MS_MANAGE_FILES_ENVIRONMENT'
];

export const MS_MANAGE_FILES_STUDY_SETTINGS_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_SETTINGS',
    'MS_MANAGE_FILES_STUDY_SETTINGS'
];

export const EDIT_GERMPLASM_PERMISSION = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'EDIT_GERMPLASM'
];

export const MG_MANAGE_FILES_PERMISSION = [
    ...EDIT_GERMPLASM_PERMISSION,
    'MG_MANAGE_FILES'
];

export const GROUP_GERMPLASM_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'GROUP_GERMPLASM'
];

export const UNGROUP_GERMPLASM_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'UNGROUP_GERMPLASM'
];

export const GERMPLASM_AUDIT_PERMISSION = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'VIEW_GERMPLASM_CHANGE_HISTORY'
];

export const CREATE_INVENTORY_LOT_PERMISSIONS = [
    ...MANAGE_GERMPLASM_PERMISSIONS,
    'MG_MANAGE_INVENTORY',
    'MG_CREATE_LOTS'
];

export const MANAGE_CROP_SETTINGS_PERMISSIONS = [
    'ADMIN',
    'CROP_MANAGEMENT',
    'MANAGE_CROP_SETTINGS',
];

export const MANAGE_GERMPLASM_LIST_PERMISSION = [
    'ADMIN',
    'LISTS',
    'MANAGE_GERMPLASM_LISTS'
];

export const QUERIES_PERMISSION = [
    'ADMIN',
    'QUERIES'
];

export const SEARCH_GERMPLASM_LISTS_PERMISSION = [
    ...MANAGE_GERMPLASM_LIST_PERMISSION, 'SEARCH_GERMPLASM_LISTS'
];

export const GERMPLASM_LIST_LABEL_PRINTING_PERMISSIONS = [
    ...MANAGE_GERMPLASM_LIST_PERMISSION,
    'GERMPLASM_LIST_LABEL_PRINTING'
];

export const STUDY_ENTRIES_LABEL_PRINTING_PERMISSIONS = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_ACTIONS',
    'MS_MANAGE_OBSERVATION_UNITS',
    'MS_EXPORT_STUDY_ENTRIES'
];

export const DESIGN_CROSSES_PERMISSIONS = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_ACTIONS',
    'MS_CROSSING_OPTIONS',
    'MS_DESIGN_NEW_CROSSES'
];

export const OBSERVATION_DATASET_LABEL_PRINTING_PERMISSIONS = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_ACTIONS',
    'MS_DESIGN_AND_PLANNING_OPTIONS',
    'MS_CREATE_PLANTING_LABELS'
];
/**
 * To simplify, we don't specify here which specific granular permission
 * needs access to the germplasm selector (e.g ADD_GERMPLASM_LIST_ENTRIES),
 * we just add the "View" type permission that gives access to the module.
 */
export const GERMPLASM_SELECTOR_PERMISSIONS = [
    ...SEARCH_GERMPLASM_PERMISSIONS,
    ...SEARCH_GERMPLASM_LISTS_PERMISSION,
    ...MANAGE_STUDIES_PERMISSIONS,
    'QUERIES',
    'GRAPHICAL_QUERIES',
];

export const STUDIES_EDITION_PERMISSIONS = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_MANAGE_OBSERVATION_UNITS',
    'DELETE_SUBOBSERVATION_DATASET',
    'MS_WITHDRAW_INVENTORY',
    'MS_CREATE_PENDING_WITHDRAWALS',
    'MS_CREATE_CONFIRMED_WITHDRAWALS',
    'MS_CANCEL_PENDING_TRANSACTIONS',
    'MS_MANAGE_FILES_OBSERVATIONS',
    'MS_CREATE_LOTS',
    'CREATE_STUDIES',
    'CLOSE_STUDY',
    'DELETE_STUDY',
    'LOCK_STUDY',
    'LOCK_STUDY_NOT_OWNED',
    'MS_GERMPLASM_AND_CHECKS',
    'MS_VIEW_GERMPLASM_AND_CHECKS',
    'MS_ADD_ENTRY_DETAILS_VARIABLES',
    'MS_MODIFY_ENTRY_DETAILS_VALUES',
    'MS_MODIFY_COLUMNS',
    'MS_REPLACE_GERMPLASM',
    'MS_ADD_NEW_ENTRIES',
    'MS_IMPORT_ENTRY_DETAILS',
    'MS_TREATMENT_FACTORS',
    'MS_VIEW_TREATMENT_FACTORS',
    'MS_ADD_TREATMENT_FACTORS_VARIABLES',
    'MS_EXPERIMENTAL_DESIGN',
    'MS_VIEW_EXPERIMENTAL_DESIGN',
    'MS_GENERATE_EXPERIMENTAL_DESIGN',
    'MS_DELETE_EXPERIMENTAL_DESIGN',
    'MS_ENVIRONMENT',
    'MS_VIEW_ENVIRONMENT',
    'MS_ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES',
    'MS_ADD_ENVIRONMENT_DETAILS_VARIABLES',
    'MS_MODIFY_ENVIRONMENT_VALUES',
    'MS_MODIFY_NUMBER_OF_ENVIRONMENTS',
    'MS_MANAGE_FILES_ENVIRONMENT',
    'MS_STUDY_SETTINGS',
    'MS_VIEW_STUDY_SETTINGS',
    'MS_ADD_STUDY_SETTINGS_VARIABLES',
    'MS_MODIFY_STUDY_SETTINGS_VALUES',
    'MS_MANAGE_FILES_STUDY_SETTINGS',
    'MS_CROSSES_AND_SELECTIONS',
    'MS_VIEW_CROSSES_AND_SELECTIONS',
    'MS_INVENTORY',
    'MS_VIEW_INVENTORY',
    'MS_SAMPLE_LISTS',
    'MS_VIEW_SAMPLE_LISTS',
    'MS_SAMPLE_LABEL_PRINTING',
    'MS_DELETE_SAMPLES',
    'MS_SSA_RESULTS',
    'MS_VIEW_SSA_RESULTS',
    'MS_SSA_SUMMARY_STATISTICS',
    'MS_SSA_MEANS_BLUE',
    'MS_OBSERVATIONS',
    'MS_VIEW_OBSERVATIONS',
    'MS_ADD_OBSERVATION_TRAIT_VARIABLES',
    'MS_RENAME_OBSERVATION_TRAIT_VARIABLES',
    'MS_ADD_OBSERVATION_SELECTION_VARIABLES',
    'MS_MANAGE_PENDING_OBSERVATIONS',
    'MS_MANAGE_CONFIRMED_OBSERVATIONS',
    'MS_ACCEPT_PENDING_OBSERVATION',
    'MS_STUDY_ACTIONS',
    'MS_CREATE_GENOTYPING_SAMPLES',
    'MS_EXECUTE_CALCULATED_VARIABLES',
    'MS_DESIGN_AND_PLANNING_OPTIONS',
    'MS_EXPORT_DESIGN_TEMPLATE',
    'MS_CREATE_PLANTING_LABELS',
    'MS_ADVANCES',
    'MS_ADVANCE_STUDY',
    'MS_ADVANCE_STUDY_FOR_PLANTS',
    'MS_ANALYZE_WITH_STA_BRAPP',
    'MS_ANALYZE_WITH_DECISION_SUPPORT',
    'MS_CREATE_SUB_OBSERVATION_UNITS',
    'MS_CHANGE_PLOT_ENTRY',
    'MS_EXPORT_STUDY_BOOK',
    'MS_EXPORT_STUDY_ENTRIES',
    'MS_CROSSING_OPTIONS',
    'MS_EXPORT_CROSSING_TEMPLATE',
    'MS_IMPORT_CROSSES',
    'MS_DESIGN_NEW_CROSSES',
    'MS_FIELD_MAP_OPTIONS',
    'MS_MAKE_FIELD_MAP',
    'MS_VIEW_FIELD_MAP',
    'MS_DELETE_FIELD_MAP',
    'MS_CREATE_GEOREFERENCE',
    'MS_EDIT_GEOREFERENCE',
    'MS_VIEW_GERMPLASM_DETAILS',
    'DELETE_STUDY_NOT_OWNED'
];

export const VIEW_GERMPLASM_DETAILS_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_VIEW_GERMPLASM_DETAILS'
];

export const VIEW_PEDIGREE_INFORMATION_PERMISSION = [
    'ADMIN',
    'GERMPLASM',
    'VIEW_PEDIGREE_INFORMATION'
];

export const VIEW_NAMES_PERMISSION = [
    'ADMIN',
    'GERMPLASM',
    'VIEW_NAMES'
];

export const LOCK_STUDY_NOT_OWNED_PERMISSIONS = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'LOCK_STUDY_NOT_OWNED'
];

export const STUDY_FOLDER_ACTIONS_ADD_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_FOLDER_ACTIONS',
    'MS_STUDY_FOLDER_ACTIONS_ADD'
];

export const STUDY_FOLDER_ACTIONS_RENAME_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_FOLDER_ACTIONS',
    'MS_STUDY_FOLDER_ACTIONS_RENAME'
];

export const STUDY_FOLDER_ACTIONS_DELETE_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_FOLDER_ACTIONS',
    'MS_STUDY_FOLDER_ACTIONS_DELETE'
];

export const STUDY_FOLDER_ACTIONS_CHANGE_PERMISSION = [
    ...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_FOLDER_ACTIONS',
    'MS_STUDY_FOLDER_ACTIONS_CHANGE'
];

export const CREATE_STUDIES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'CREATE_STUDIES'];


export const VIEW_GERMPLASM_DETAILS = ['MANAGE_GERMPLASM', 'VIEW_GERMPLASM'];
export const MODIFY_COLUMNS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_MODIFY_COLUMNS'];
export const REPLACE_GERMPLASM_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_REPLACE_GERMPLASM'];
export const ADD_NEW_ENTRIES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_ADD_NEW_ENTRIES'];
export const ADD_ENTRY_DETAILS_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_ADD_ENTRY_DETAILS_VARIABLES'];
export const MODIFY_ENTRY_DETAILS_VALUES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_MODIFY_ENTRY_DETAILS_VALUES'];
export const IMPORT_ENTRY_DETAILS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_IMPORT_ENTRY_DETAILS'];

// Environment
export const ADD_ENVIRONMENT_DETAILS_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_ENVIRONMENT', 'MS_ADD_ENVIRONMENT_DETAILS_VARIABLES'];
export const ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_ENVIRONMENT', 'MS_ADD_ENVIRONMENTAL_CONDITIONS_VARIABLES'];
export const MODIFY_NUMBER_OF_ENVIRONMENT_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_ENVIRONMENT', 'MS_MODIFY_NUMBER_OF_ENVIRONMENTS'];
export const MODIFY_ENVIRONMENT_VALUES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_ENVIRONMENT', 'MS_MODIFY_ENVIRONMENT_VALUES'];


export const MANAGE_PENDING_OBSERVATION_VALUES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_MANAGE_PENDING_OBSERVATIONS'];
export const MANAGE_CONFIRMED_OBSERVATION_VALUES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_MANAGE_CONFIRMED_OBSERVATIONS'];
export const MANAGE_ACCEPT_PENDING_OBSERVATION_VALUES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_ACCEPT_PENDING_OBSERVATION'];

export const ADD_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_ADD_OBSERVATION_TRAIT_VARIABLES'];
export const RENAME_OBSERVATION_TRAIT_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_RENAME_OBSERVATION_TRAIT_VARIABLES'];

export const ADD_OBSERVATION_SELECTION_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_ADD_OBSERVATION_SELECTION_VARIABLES'];

export const ADD_STUDY_SETTINGS_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_SETTINGS', 'MS_ADD_STUDY_SETTINGS_VARIABLES'];
export const MODIFY_STUDY_SETTINGS_VALUES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_SETTINGS', 'MS_MODIFY_STUDY_SETTINGS_VALUES'];


// Experimental Design
export const DELETE_EXPERIMENTAL_DESIGN_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_DELETE_EXPERIMENTAL_DESIGN'];
export const GENERATE_EXPERIMENTAL_DESIGN_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_GENERATE_EXPERIMENTAL_DESIGN'];
export const ADD_OPTIONAL_DESIGN_VARS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_ADD_OPTIONAL_DESIGN_VARIABLES'];
export const MOD_OPTIONAL_DESIGN_VARS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_MODIFY_OPTIONAL_DESIGN_VARIABLES'];
export const MOD_COLS_DESIGN_VARS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_MODIFY_COLUMNS_EXPERIMENTAL_DESIGN'];
export const EDIT_TREATMENT_FACTORS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_EDIT_TREATMENT_FACTORS'];
export const DELETE_STUDY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'DELETE_STUDY'];
export const DELETE_STUDY_NOT_OWNED_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'DELETE_STUDY_NOT_OWNED'];
export const CLOSE_STUDY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'CLOSE_STUDY'];
export const LOCK_STUDY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'LOCK_STUDY', 'LOCK_STUDY_NOT_OWNED'];


export const CREATE_PLANTING_LABELS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_DESIGN_AND_PLANNING_OPTIONS', 'MS_CREATE_PLANTING_LABELS'];
export const EXPORT_DESIGN_TEMPLATE_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_DESIGN_AND_PLANNING_OPTIONS', 'MS_EXPORT_DESIGN_TEMPLATE'];
export const IMPORT_DESIGN_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_DESIGN_AND_PLANNING_OPTIONS', 'MS_IMPORT_DESIGN'];
export const PREPARE_INVENTORY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_DESIGN_AND_PLANNING_OPTIONS', 'MS_PREPARE_INVENTORY'];
export const CREATE_LOTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_CREATE_LOTS'];
export const EXECUTE_CALCULATED_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_EXECUTE_CALCULATED_VARIABLES'];
export const CREATE_GENOTYPING_SAMPLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_CREATE_GENOTYPING_SAMPLES'];

export const EXPORT_CROSSING_TEMPLATE_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_CROSSING_OPTIONS', 'MS_EXPORT_CROSSING_TEMPLATE'];
export const IMPORT_CROSSES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_CROSSING_OPTIONS', 'MS_IMPORT_CROSSES'];
export const DESIGN_NEW_CROSSES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_CROSSING_OPTIONS', 'MS_DESIGN_NEW_CROSSES'];

export const VIEW_STUDY_SETTINGS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_SETTINGS', 'MS_VIEW_STUDY_SETTINGS'];
export const VIEW_GERMPLASM_AND_CHECKS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_GERMPLASM_AND_CHECKS', 'MS_VIEW_GERMPLASM_AND_CHECKS'];
export const VIEW_TREATMENT_FACTORS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_TREATMENT_FACTORS', 'MS_VIEW_TREATMENT_FACTORS'];
export const VIEW_EXPERIMENTAL_DESIGN_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_EXPERIMENTAL_DESIGN', 'MS_VIEW_EXPERIMENTAL_DESIGN'];
export const VIEW_ENVIRONMENT_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_ENVIRONMENT', 'MS_VIEW_ENVIRONMENT'];
export const VIEW_CROSSES_AND_SELECTIONS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_CROSSES_AND_SELECTIONS', 'MS_VIEW_CROSSES_AND_SELECTIONS'];
export const VIEW_INVENTORY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_INVENTORY', 'MS_VIEW_INVENTORY'];
export const VIEW_SAMPLE_LISTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SAMPLE_LISTS', 'MS_VIEW_SAMPLE_LISTS'];

export const SAMPLE_LABEL_PRINTING_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SAMPLE_LISTS', 'MS_SAMPLE_LABEL_PRINTING'];
export const DELETE_SAMPLE_LISTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SAMPLE_LISTS', 'MS_DELETE_SAMPLES'];
export const MS_IMPORT_GENOTYPES_FROM_GIGWA = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SAMPLE_LISTS', 'MS_IMPORT_GENOTYPES_OPTIONS', 'MS_IMPORT_GENOTYPES_FROM_GIGWA'];
export const MS_IMPORT_GENOTYPES_FROM_FILE = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SAMPLE_LISTS', 'MS_IMPORT_GENOTYPES_OPTIONS', 'MS_IMPORT_GENOTYPES_FROM_FILE'];

export const VIEW_SINGLE_SITE_ANALYSIS_RESULTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SSA_RESULTS', 'MS_VIEW_SSA_RESULTS'];
export const VIEW_OBSERVATIONS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_OBSERVATIONS', 'MS_VIEW_OBSERVATIONS'];
export const VIEW_SAMPLE_GENOTYPES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SAMPLE_GENOTYPES', 'MS_VIEW_SAMPLE_GENOTYPES'];
export const SSA_SUMMARY_STATISTICS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SSA_RESULTS', 'MS_SSA_SUMMARY_STATISTICS'];
export const SSA_MEANS_BLUE_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SSA_RESULTS', 'MS_SSA_MEANS_BLUE'];
export const ADD_TREATMENT_FACTORS_VARIABLES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_TREATMENT_FACTORS', 'MS_ADD_TREATMENT_FACTORS_VARIABLES'];
export const ANALYZE_WITH_STA_BRAPP_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_ANALYZE_WITH_STA_BRAPP'];
export const ANALYZE_WITH_DECISION_SUPPORT_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_ANALYZE_WITH_DECISION_SUPPORT'];
export const ANALYZE_WITH_TRIALDATAEXP_BRAPP_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_ANALYZE_WITH_TRIAL_DATA_EXP'];
export const ADVANCES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_ADVANCES', 'MS_ADVANCE_STUDY', 'MS_ADVANCE_STUDY_FOR_PLANTS'];
export const ADVANCE_STUDY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_ADVANCES', 'MS_ADVANCE_STUDY'];
export const ADVANCE_STUDY_FOR_PLANTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_ADVANCES', 'MS_ADVANCE_STUDY_FOR_PLANTS'];
export const CREATE_SUB_OBSERVATION_UNITS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_MANAGE_OBSERVATION_UNITS', 'MS_CREATE_SUB_OBSERVATION_UNITS'];
export const DELETE_SUB_OBSERVATION_UNITS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_MANAGE_OBSERVATION_UNITS', 'DELETE_SUBOBSERVATION_DATASET'];
export const EDIT_SUB_OBSERVATION_UNITS_NUMBER_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_MANAGE_OBSERVATION_UNITS', 'MS_EDIT_SUB_OBSERVATION_UNITS_NUMBER'];
export const DELETE_SSA_RESULTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SSA_RESULTS', 'DELETE_SSA_RESULTS'];
export const EXPORT_SSA_RESULTS_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_SSA_RESULTS', 'MS_EXPORT_SSA_RESULTS'];
export const CHANGE_PLOT_ENTRY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_MANAGE_OBSERVATION_UNITS', 'MS_CHANGE_PLOT_ENTRY'];
export const EXPORT_STUDY_BOOK_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_MANAGE_OBSERVATION_UNITS', 'MS_EXPORT_STUDY_BOOK'];
export const EXPORT_STUDY_ENTRIES_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_MANAGE_OBSERVATION_UNITS', 'MS_EXPORT_STUDY_ENTRIES'];
export const MAKE_FIELD_MAP_PERMSISSION = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_FIELD_MAP_OPTIONS', 'MS_MAKE_FIELD_MAP'];
export const VIEW_FIELD_MAP_PERMSISSION = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_FIELD_MAP_OPTIONS', 'MS_VIEW_FIELD_MAP'];
export const DELETE_FIELD_MAP_PERMSISSION = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_FIELD_MAP_OPTIONS', 'MS_DELETE_FIELD_MAP'];
export const CREATE_GEOREFERENCE_PERMSISSION = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_FIELD_MAP_OPTIONS', 'MS_CREATE_GEOREFERENCE'];
export const EDIT_GEOREFERENCE_PERMSISSION = [...MANAGE_STUDIES_PERMISSIONS, 'MS_STUDY_ACTIONS', 'MS_FIELD_MAP_OPTIONS', 'MS_EDIT_GEOREFERENCE'];
export const VIEW_PEDIGREE_INFORMATION_PERMISSIONS = ['ADMIN', 'GERMPLASM', 'VIEW_PEDIGREE_INFORMATION'];
export const VIEW_NAMES_PERMISSIONS = ['ADMIN', 'GERMPLASM', 'VIEW_NAMES'];
export const MS_WITHDRAW_INVENTORY_PERMISSIONS = [...MANAGE_STUDIES_PERMISSIONS,
    'MS_STUDY_ACTIONS',
    'MS_MANAGE_OBSERVATION_UNITS',
    'MS_WITHDRAW_INVENTORY'
];
export const MS_CANCEL_PENDING_TRANSACTIONS = [...MS_WITHDRAW_INVENTORY_PERMISSIONS, 'MS_CANCEL_PENDING_TRANSACTIONS'];

export const MS_CREATE_CONFIRMED_WITHDRAWALS = [
    ...MS_WITHDRAW_INVENTORY_PERMISSIONS,
    'MS_CREATE_CONFIRMED_WITHDRAWALS'
];

export const MANAGE_TRANSACTIONS_PERMISSIONS = [
    ...MANAGE_INVENTORY_PERMISSIONS,
    'MANAGE_TRANSACTIONS',
];

export const WITHDRAW_INVENTORY = [
    'WITHDRAW_INVENTORY',
    'CREATE_PENDING_WITHDRAWALS',
    'CREATE_CONFIRMED_WITHDRAWALS'
];

export const DEPOSIT_INVENTORY = [
    'DEPOSIT_INVENTORY',
    'CREATE_PENDING_DEPOSITS',
    'CREATE_CONFIRMED_DEPOSITS'
];


export const ALL_LOT_PERMISSIONS = [
    ...MANAGE_LOT_PERMISSIONS,
    'VIEW_LOTS',
    'IMPORT_LOTS',
    'CREATE_LOTS',
    'UPDATE_LOTS',
    'CLOSE_LOTS',
    'MERGE_LOTS',
    'SPLIT_LOT',
    ...WITHDRAW_INVENTORY,
    ...DEPOSIT_INVENTORY
];

export const ALL_TRANSACTION_PERMISSIONS = [
    ...MANAGE_TRANSACTIONS_PERMISSIONS,
    'VIEW_TRANSACTIONS',
    'CONFIRM_TRANSACTIONS',
    'IMPORT_TRANSACTION_UPDATES',
    'CANCEL_PENDING_TRANSACTIONS'
];

export const VIEW_LOTS_PERMISSIONS = [
    ...MANAGE_LOT_PERMISSIONS, 'VIEW_LOTS'
];

export const VIEW_TRANSACTIONS_PERMISSIONS = [
    ...MANAGE_TRANSACTIONS_PERMISSIONS, 'VIEW_TRANSACTIONS'
];

export const UPDATE_LOT_BALANCE_PERMISSIONS = [
    ...MANAGE_LOT_PERMISSIONS, 'UPDATE_LOT_BALANCE'
];


export const MULTI_TRAIT_QUERY_PERMISSIONS = [
    ...QUERIES_PERMISSION, 'MULTI_TRAIT_QUERY'
];

export const HEAD_TO_HEAD_QUERY_PERMISSIONS = [
    ...QUERIES_PERMISSION, 'HEAD_TO_HEAD_QUERY'
];

export const ONTOLOGY_MANAGER_PERMISSIONS = [
    'ADMIN',
    'CROP_MANAGEMENT',
    'MANAGE_ONTOLOGIES'
];
